import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/core/useAuth";
import { Loader } from "@mantine/core";

export function PublicRoute({ children }) {
  const { user, staffProfile, isLoading } = useAuth();
  const location = useLocation();

  // Only redirect if we're definitely authenticated (not just loading)
  if (!isLoading && user && staffProfile) {
    // Use location state if available, otherwise fallback to root
    const to = location.state?.from?.pathname || "/";
    return <Navigate to={to} replace={false} />;
  }

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        <Loader color="blue" size="xl" type="bars" />
      </div>
    );
  }

  return children;
}
